export default __webpack_public_path__ + "static/media/cebolla.f5cf1b90.png";